module.exports = __webpack_public_path__ + "static/media/matching.9bbacddf.png";